import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["WagmiProvider"] */ "/app/src/providers/WagmiProvider.tsx");
